import React from 'react';
import { Col, Icon, Tooltip, message } from 'antd';
import MultiSelectDatePicker from '../MultiSelectDatePicker';
import GarageSelect from '$app/shared/components/GarageFilter';
import LoadingSpinner from '$app/shared/components/LoadingSpinner';
import { StyledRow, DeleteCol } from './styled';

const AvailabilityRows = ({ garages, rescheduleAvailabilityRows, setRescheduleAvailabilityRows }) => {
  if (!garages) return <LoadingSpinner />;

  const deleteGarageRow = (rowIndex) => {
    const updatedRows = rescheduleAvailabilityRows.filter((row, i) => rowIndex !== i);
    setRescheduleAvailabilityRows(updatedRows);
  };

  const updateGarageId = (newValue, rowIndex) => {
    const updatedRescheduleAvailabilityRows = [...rescheduleAvailabilityRows];
    const targetRow = updatedRescheduleAvailabilityRows[rowIndex];
    targetRow.garageId = newValue;
    setRescheduleAvailabilityRows(updatedRescheduleAvailabilityRows);
  };

  const updateDates = (newValue, rowIndex) => {
    const updatedRescheduleAvailabilityRows = [...rescheduleAvailabilityRows];
    const targetRow = updatedRescheduleAvailabilityRows[rowIndex];
    targetRow.dates = newValue;
    setRescheduleAvailabilityRows(updatedRescheduleAvailabilityRows);
  };

  const DeleteRowColumn = ({ rowIndex }) => (
    <DeleteCol xs={2}>
      <a onClick={() => deleteGarageRow(rowIndex)}>
        <Tooltip title="Delete entire row" placement="left">
          <Icon type="delete" />
        </Tooltip>
      </a>
    </DeleteCol>
  );

  return rescheduleAvailabilityRows.map((row, i) => {
    const rowDates = rescheduleAvailabilityRows[i].dates;
    const rowGarageId = rescheduleAvailabilityRows[i].garageId;

    return (
      <StyledRow key={i}>
        <Col xs={11}>
          <GarageSelect
            onSelect={(garage) => updateGarageId(garage, i)}
            value={rowGarageId}
            garages={garages}
          />
        </Col>
        <Col xs={11}>
          <MultiSelectDatePicker value={rowDates} onChange={(dates) => updateDates(dates, i)} />
        </Col>
        <DeleteRowColumn rowIndex={i} />
      </StyledRow>
    );
  });
};

export default AvailabilityRows;
